import type { User } from '../types';
import { ItemDetailsSection } from './SavedItemDetails';
import { TravellerPill } from './UserAvatar';

/**
 * Who an item is for. Missing (Everyone) includes anyone who joins later;
 * a fixed list never grows. Assignment is a view/participation fact, never an
 * access grant (plan.md, Assignments and review).
 */
export function TravellerAssignment({ travellers, value, onChange }: {
  travellers: User[]; value?: string[]; onChange: (ids: string[] | undefined) => void;
}) {
  if (travellers.length < 2 && !value) return null;
  const selected = value ?? [];
  // The last selected traveller can't be removed: an item for nobody is an error, not a choice.
  const toggle = (id: string) => onChange(selected.includes(id)
    ? (selected.length > 1 ? selected.filter(other => other !== id) : selected)
    : [...selected, id]);
  return <ItemDetailsSection label="Travellers">
    <div className="itinerary-branch-filter w-fit" role="group" aria-label="Who is this for?">
      <button type="button" aria-pressed={!value} onClick={() => onChange(undefined)}>Everyone</button>
      <button type="button" aria-pressed={!!value} onClick={() => !value && onChange(travellers.map(t => t.id))}>Selected travellers</button>
    </div>
    <p className="text-sm text-app-sub">{value ? 'Only these travellers. Future joiners won’t be added.' : 'Includes everyone who joins this trip later.'}</p>
    {value && <div className="flex flex-wrap gap-2">{travellers.map(p =>
      <TravellerPill key={p.id} user={p} selected={selected.includes(p.id)} onClick={() => toggle(p.id)} />)}</div>}
  </ItemDetailsSection>;
}

/** Read-only line for saved items; Everyone shows nothing. */
export function AssignedTravellers({ ids, travellers = [] }: { ids?: string[]; travellers?: User[] }) {
  if (!ids) return null;
  const names = ids.map(id => travellers.find(t => t.id === id)?.name.split(' ')[0]).filter(Boolean);
  return <p className="text-sm text-app-text"><span className="text-app-sub">Travellers:</span> {names.length ? names.join(', ') : 'No current travellers'}</p>;
}
